import { useEffect, useState } from "react";
import invalidPng from "./assets/invalid.png";
import MoonLoader from "react-spinners/MoonLoader";


function App() {
  const [invalid, setInvalid] = useState(false);
  const [response, setResopnse] = useState("redirecting");

  useEffect(() => {
    const redirect = async () => {
      const url = new URL(window.location.href);
      const action_id = url.searchParams.get("acc");
      const request_id = url.searchParams.get("req");
      if (action_id && request_id) {
        try {
          const response = await fetch(`https://zoho-sign-implementation-875040727.development.catalystserverless.com/server/Zoho-Sign-Imp/retrieve_sign_url`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ Action_ID: action_id, Request_ID: request_id })
          });
          const data = await response.json();
          console.log(data)
          if (data.status === "Success") {
            window.location.href = data.details;
          } else {
            setResopnse("Invalid Request");
            setInvalid(true)
          }
        } catch (error) {
          setResopnse("Invalid Request");
          setInvalid(true)
        }
      } else {
        setResopnse("Invalid Request");
        setInvalid(true)
      }
    }
    redirect();
  }, []);
  return (
    <div className="App">
      {invalid && (
        <>
          <img src={invalidPng} alt="" />
        </>
      )}
      <div >
        {response === "redirecting" ? (
          <MoonLoader color="#000" size={50} />
        ) : (
          <h1 className="response">
          {response}
          </h1>
        )}
      </div>
    </div>
  );
}

export default App;
